import React from "react";
import "./BlogPost.css";
import ReactMarkdown from 'react-markdown'

export default function BlogPost({ blog }) {
  return (
    <div style={{fontSize:'15px', color:'grey'}}>
      {/* <div>
        <h4>{blog.title}</h4>
        <h5>{blog.subtitle}</h5>
        <p><em>{blog.author}</em></p>
        <p>{blog.dateCreated}</p>
      </div> */}
      <ReactMarkdown >{blog.description}</ReactMarkdown>
    </div>
  );
  
}

